

































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import RequirePasscode from '~/components/Wallet/RequirePasscode.vue';
import ExclamationTriangle from '~/components/SvgIcons/ExclamationTriangle.vue';
import { IRequiredAllowance } from '~/store/games/types';

enum DisplayState {
  DETAILS = 'DETAILS',
  ACCEPT = 'ACCEPT',
  DECLINE = 'DECLINE',
}

@Component({
  components: { RequirePasscode, ExclamationTriangle },
})
export default class GiveAllowance extends Vue {
  @Prop({ type: Boolean })
  readonly showModal!: boolean;

  @Prop(Array) readonly requiredAllowances!: Array<IRequiredAllowance>;
  @Prop(String) readonly gameName!: string;
  @Prop(String) readonly gameImg!: string;

  DisplayState = DisplayState;
  displayState = DisplayState.DETAILS;
  inputHeading = 'Please enter the temporary transfer code ';
  requiredTransferCode = 'galachain';

  get allowanceExplanation() {
    const requiredAllowancesString = this.requiredAllowances.reduce(
      (string, token, index, array) => {
        if (!index) {
          return token.type;
        } else if (index === array.length - 1) {
          return `${string} and ${token.type}`;
        } else {
          return `${string}, ${token.type}`;
        }
      },
      '',
    );
    return ` is requesting allowances to spend unlimited ${requiredAllowancesString} token${
      this.requiredAllowances.length > 1 ? 's' : ''
    }`;
  }

  accept() {
    this.displayState = this.DisplayState.ACCEPT;
  }

  decline() {
    this.displayState = this.DisplayState.DECLINE;
  }

  goBack() {
    this.displayState = this.DisplayState.DETAILS;
  }

  matchInstructions(input: string) {
    return (
      input === this.requiredTransferCode ||
      `Input must match "${this.requiredTransferCode}" per the instructions above.`
    );
  }

  grantAllowance() {
    // TODO: use graphql mutation when ready. Currently, the game will automatically give the allowances when a game is started
    return { success: true };
  }

  handleGrantComplete({ success }: { success: boolean }) {
    if (success) {
      this.$emit('success');
      // UA tracking
      this.$ua.trackGameGiveAllowanceCompleteEvent({
        game: this.gameName,
        message: this.allowanceExplanation,
      });
    } else {
      const errorMessage = 'something went wrong';
      // UA tracking
      this.$ua.trackGameGiveAllowanceErrorEvent({
        game: this.gameName,
        error: errorMessage,
      });
      this.$emit('error', errorMessage);
    }
  }
}
